import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { BundledResponses, DaisyChainConversation, DaisyChainConversationArtifact, CreatorType, CreatedArtifactMetadata } from '../data/daisychain';
import { DataService } from '../data/data.service';
import { DomSanitizer } from '@angular/platform-browser';
import { DaisychainResponseComponent } from '../daisychain-response/daisychain-response.component';
import moment from 'moment';
import videojs from 'video.js';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-daisychain-conversations-viewer',
    templateUrl: './daisychain-conversations-viewer.component.html',
    styleUrls: ['./daisychain-conversations-viewer.component.css']
})

export class DaisychainConversationsViewerComponent implements OnInit
{
    @Input() studentID: number;
    @Input() defaultCourseCode: string;

    conversations: DaisyChainConversation[];
    createdArtifacts: CreatedArtifactMetadata[];
    completedConversations: DaisyChainConversation[];
    selectedConversation: DaisyChainConversation;
    selectedArtifactMetadata: CreatedArtifactMetadata;
    selectedConversationArtifact: DaisyChainConversationArtifact;
    isLoadingArtifact: boolean;
    bundledResponses: BundledResponses[];
    selectedResponse: DaisychainResponseComponent;
    isLoadingInitialData: boolean;
    constructor(
        protected sanitizer: DomSanitizer,
        protected dataService: DataService,
        private http: HttpClient
    ) { }

    ngOnInit()
    {
        this.isLoadingInitialData = true;
        if (!this.createdArtifacts) this.createdArtifacts = new Array();

        this.http.get<DaisyChainConversation[]>('assets/daisychain-conversations.json').subscribe(conversations =>
        {
            if (conversations)
            {
                this.conversations = conversations;
                this.fetchArtifactCreationMetadata();
            }
        });
    }

    fetchArtifactCreationMetadata()
    {
        if (!this.conversations)
        {
            console.error("No conversations found, can't fetch conversation artifacts.");
            return;
        }
        let finishedCount = 0;
        this.conversations.forEach(c =>
        {
            this.dataService.getArtifactCreationMetadata(this.studentID, c.ConversationArtifactID).subscribe(metaData =>
            {
                if (metaData && Array.isArray(metaData))
                {
                    this.createdArtifacts = this.createdArtifacts.concat(metaData);
                }
                finishedCount++;
                if (finishedCount === this.conversations.length)
                {
                    this.createdArtifacts.sort((a, b) =>
                    {
                        return moment(a.DateGenerated).toDate().getTime() - moment(b.DateGenerated).toDate().getTime();
                    });
                    this.updateConvoList();
                }
            })
        });
    }


    updateConvoList()
    {
        console.log("updtaing convo list");
        var mostRecentConversation = null;
        this.conversations.forEach(c =>
        {
            c.CreatedArtifacts = new Array();
            this.createdArtifacts.forEach(ca =>
            {
                if (c.ConversationArtifactID.toLowerCase() == ca.ArtifactID.toLowerCase())
                {
                    console.log("found conversation artifact");
                    c.IsCompletedByStudent = true;
                    c.CreatedArtifacts.push(ca);

                    if (!mostRecentConversation ||
                        moment(this.conversations[this.conversations.indexOf(c)].CreatedArtifacts[this.conversations[this.conversations.indexOf(c)].CreatedArtifacts.length - 1].DateGenerated).toDate()
                        < moment(ca.DateGenerated).toDate())
                    {
                        mostRecentConversation = c;
                    }
                }
            });
        });
        this.completedConversations = this.conversations.filter(x => x.IsCompletedByStudent);
        if (this.completedConversations && this.completedConversations.length > 0)
        {
            console.log("selecting most recent conversation by default");
            this.handleConversationSelection(this.conversations[this.conversations.indexOf(mostRecentConversation)]);
        }
        this.isLoadingInitialData = false;
    }

    handleConversationSelection(convo: DaisyChainConversation): void
    {
        if (this.selectedConversation != convo)
        {
            this.selectedConversation = convo;
            this.selectedConversation.CreatedArtifacts;
            if (this.selectedConversation.CreatedArtifacts && this.selectedConversation.CreatedArtifacts.length > 0)
            {
                this.handleConversationInstanceSelection(this.selectedConversation.CreatedArtifacts[this.selectedConversation.CreatedArtifacts.length - 1]);
            }
        }
    }

    handleConversationInstanceSelection(artifact: CreatedArtifactMetadata): void
    {
        if (this.selectedArtifactMetadata != artifact)
        {
            this.selectedArtifactMetadata = artifact;
            this.selectedConversationArtifact = null;
            this.isLoadingArtifact = true;
            this.dataService.getArtifact(this.studentID, this.selectedConversation.ConversationArtifactID, this.selectedArtifactMetadata.StartedActivityID).subscribe(a =>
            {
                this.selectedConversationArtifact = a;
                this.bundledResponses = new Array();
                var currentBundled = new BundledResponses;
                currentBundled.BotResponses = new Array();

                if (this.selectedConversationArtifact)
                {
                    this.selectedConversationArtifact.Responses.forEach(response =>
                    {
                        if (response.CreatorType == CreatorType.Student)
                        {
                            currentBundled.StudentResponse = response;
                            this.bundledResponses.push(currentBundled);
                            currentBundled = new BundledResponses;
                            currentBundled.BotResponses = new Array();
                        } else
                        {
                            currentBundled.BotResponses.push(response);
                        }
                    });
                }

                this.bundledResponses = this.bundledResponses.filter(x => x.BotResponses && x.BotResponses.length != 0);
                this.isLoadingArtifact = false;
            });
        }
    }

    DateReturner(artifact: CreatedArtifactMetadata): string
    {
        return moment(artifact.DateGenerated).format('MM/DD/YYYY');
    }

    playWasCalled(id: string)
    {
        var players = new Array();
        for (var x = 0; x < Object.keys(videojs.players).length; x++)
        {
            // Assign the player name to setPlayer
            var setPlayer = Object.keys(videojs.players)[x];
            players.push(setPlayer);
        }
        // Loop through the array of players
        for (var i = 0; i < players.length; i++)
        {
            // Get the player(s) that did not trigger the play event
            if (players[i] != id)
            {
                // Pause the other player(s)
                if (videojs.getPlayer(players[i])) videojs.getPlayer(players[i]).pause();
            }
        }
    }
}
